import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'store/modals/actions';
import get from 'lodash/get';
import useModalShortcuts from 'Hooks/useModalShortcuts';
import { MODAL_SCHEDULE_DETAIL } from 'store/modals/modals';
import { selectAssetsTags, selectSchedulerDetail, selectSelectedSection, selectServicesTags, selectVulnsTags } from 'store/Schedule/selectors';
import { resetDetail, saveSchedule } from 'store/Schedule/actions';
import Button from 'shared/ui/Button';
import CancelButton from 'shared/ui/CancelButton';
import {
  Wrapper, WrapperButtons, Title
} from './styled';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_SCHEDULER, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const Header = ({ dataToSave }) => {
  const dispatch = useDispatch();
  const schedulerDetail = useSelector(selectSchedulerDetail);
  const [description, setDescription] = useState(get(schedulerDetail, 'value.description', ''));
  const section = useSelector(selectSelectedSection);
  const type = section === 'scheduledAgents' ? 'agent' : 'cloud_agent';
  const assetsTagsAdded = useSelector(selectAssetsTags);
  const vulnsTagsAdded = useSelector(selectVulnsTags);
  const servicesTagsAdded = useSelector(selectServicesTags);
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_SCHEDULER, PERMISSION_TYPES.PATCH));

  useEffect(() => {
    setDescription(get(schedulerDetail, 'value.description', ''));
  }, [schedulerDetail]);

  const onClose = () => dispatch(closeModal(MODAL_SCHEDULE_DETAIL));

  const cancel = () => {
    onClose();
    dispatch(resetDetail());
  };

  const onSave = () => {
    if (allowedByRole) {
      const tags = { host_tag: assetsTagsAdded, vuln_tag: vulnsTagsAdded, service_tag: servicesTagsAdded };
      const workspacesNames = dataToSave.workspaces.map((ws) => {
        if (ws.name) {
          return ws.name;
        } else {
          return ws;
        }
      });
      dispatch(saveSchedule(
        get(schedulerDetail, 'value.id', 0),
        dataToSave.currentAgent.value.id,
        dataToSave.crontab.name,
        dataToSave.active,
        dataToSave.crontab.expression,
        dataToSave.description,
        dataToSave.tool?.id,
        dataToSave.parameters,
        workspacesNames,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        tags,
        type,
        dataToSave.severityRange
      ));
      onClose();
    }
  };

  useModalShortcuts({
    id: 'scheduler-detail',
    onSave: allowedByRole ? onSave : undefined,
    onCancel: cancel,
    saveLabel: 'Save',
    cancelLabel: 'Cancel'
  });

  return (
    <Wrapper>
      <Title children={ description } />
       <WrapperButtons>
          <CancelButton onClick={ cancel }>Cancel</CancelButton>
          <Button onClick={ onSave } disabled={ !allowedByRole }>Save</Button>
       </WrapperButtons>
    </Wrapper>
  );
};

export default Header;
